/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable max-len */

import { SystemAuthInsertTokenGet, SystemAuthRefreshToken } from '@/js/api/system';
import router, { resetRouter } from '@/router';
import { ElMessage } from 'element-plus';
import { store } from '@/store';

/** 登出，同步所有頁籤 */
export const TabsLogout = () => {
  window.sessionStorage.setItem(
    'token',
    JSON.stringify({
      token: '',
      time: '',
    }),
  );
  window.sessionStorage.setItem('MainMenu', '');
  window.localStorage.setItem('logout', Date.now());
  resetRouter();

  // 導向登入頁
  return '/login';
};

/**
 * 登入 / 另開分頁
 * @param {*} toPath
 * @returns
 */
export const TabsLogin = (toPath) => {
  const token = JSON.parse(sessionStorage.getItem('token')).token || '';
  const isAdmin = sessionStorage.getItem('is_admin') === 'true';
  const buList = store.getters.getBUlist;

  console.log('TabsLogin toPath', toPath);
  console.log('TabsLogin token', token);
  console.log('TabsLogin buList', buList);

  if (!token) {
    return '/login';
  }

  // 取得 BU
  store.dispatch('getBUSysList', { msg: 'Get Bu list error. Msg:' });

  // 預設目標BU
  let targetBU = buList[0];

  if (toPath) {
    const buKeyIndex = toPath.indexOf('bu_key=');
    if (buKeyIndex > -1) {
      const buKey = toPath.substring(buKeyIndex + 7, buKeyIndex + 7 + 36);
      const found = buList.find((x) => x.sys_bu === buKey);
      if (found) targetBU = found;
    }
  } else {
    if (isAdmin) {
      const foundSystem = buList.find((x) => x.sys_bu === '.');
      if (foundSystem) targetBU = foundSystem;
      store.commit('setNowBU', targetBU);
      sessionStorage.setItem('nowShowing', JSON.stringify(targetBU));
      return '/system/As_2';
    }

    store.commit('setNowBU', targetBU);
    sessionStorage.setItem('nowShowing', JSON.stringify(targetBU));
    return '/index';
  }

  // 設定 nowShowing
  if (toPath && toPath.includes('system')) {
    if (isAdmin) {
      sessionStorage.setItem('nowShowing', JSON.stringify({ re_name: 'System', sys_bu: '.' }));
      return toPath;
    }
    sessionStorage.setItem('nowShowing', JSON.stringify(targetBU));
    return '/index';
  }

  // BU 頁面
  sessionStorage.setItem('nowShowing', JSON.stringify(targetBU));
  return toPath || '/index';
};

const SyncSesstionStorageFn = (event) => {
  // 監聽 localstorage 事件
  // console.log(event);
  if (event.key === 'getSessionStorageData') {
    // 如果localstorage 發出需要Session 資訊，那就設定 sessionStorageData 至Local
    window.localStorage.setItem('sessionStorageData', JSON.stringify(window.sessionStorage));
    window.localStorage.removeItem('sessionStorageData');
  }
  if (event.key === 'sessionStorageData') {
    // 如果localstorage 發出 設定sessionStorageData，那就把值填入至Session
    const data = event.newValue ? JSON.parse(event.newValue) : JSON.parse(event.oldValue);
    for (const key in data) {
      window.sessionStorage.setItem(key, data[key]);
    }
    store.commit('setUser', data.account); // 複製後將全域 workdir 值寫入使上傳順利可以順利進行
    //
  } else if (event.key === 'logout') {
    window.localStorage.removeItem('logout');
    window.sessionStorage.clear();
    // window.sessionStorage.setItem('token', JSON.stringify({
    //   token: '',
    //   time: '',
    // }));
    resetRouter();
    router.push('/login'); // 導向登入頁
  } else if (event.key === 'login') {
    window.localStorage.removeItem('login');
    router.push('/home'); // 導向登入頁
  }
};

/** 觸發同步所有頁籤的 Session => 應該是在開新頁籤的時候觸發 */
export const TriggerSyncSesstionStorage = () => {
  window.localStorage.setItem('sessionStorageData', JSON.stringify(window.sessionStorage));
  window.localStorage.removeItem('sessionStorageData');
};

export const SyncSesstionStorage = () => {
  // 掛載監聽 localstroage 事件
  window.addEventListener('storage', SyncSesstionStorageFn);
  if (!window.sessionStorage.length) {
    window.localStorage.setItem('getSessionStorageData', Date.now());
  }
};

export const SyncAutoReflesh = () => {
  // 1分鐘秒檢查一次，自動更新token
  window.setInterval(() => {
    if (router.options.history.state.current !== '/login') {
      const RefreshTokenMinutes =
        parseFloat(process.env.VUE_APP_RefreshTokenMinutes || 20, 10) * 60 * 1000;
      const Token = JSON.parse(sessionStorage.getItem('token')) || false;
      const TokenTime = Token ? Token.time : 0;
      const Now = Date.now();
      if (Token && Token.token && TokenTime && Now > RefreshTokenMinutes + TokenTime) {
        SystemAuthRefreshToken()
          .then((res) => {
            if (res.data.success) {
              // 重新設定 token
              sessionStorage.setItem(
                'token',
                JSON.stringify({
                  token: res.data.result,
                  time: Date.now(),
                }),
              );
              SystemAuthInsertTokenGet();
              TriggerSyncSesstionStorage();
            } else {
              ElMessage({ showClose: true, message: res.data.msg, type: 'error', duration: 0 });
              TabsLogout();
            }
          })
          .catch((error) => {
            ElMessage({ showClose: true, message: error, type: 'error', duration: 0 });
            TabsLogout();
          });
      }
    }
  }, 60000);
};

const SyncClickFn = () => {
  // 有在操作就記錄點擊時的當下時間(事件)
  if (router.options.history.state.current !== '/login') {
    window.localStorage.setItem('OperatorTime', Date.now());
    TriggerSyncSesstionStorage(); // 點擊時更新所有 session 時間
  }
};

export const SyncClick = () => {
  // 有在操作就記錄點擊時的當下時間
  window.addEventListener('click', SyncClickFn);
};
